import { render, staticRenderFns } from "./LevelList.vue?vue&type=template&id=3478ca91&"
import script from "./LevelList.vue?vue&type=script&lang=js&"
export * from "./LevelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports